module.exports = __webpack_public_path__ + "static/media/box_in7.81f3b3cf.png";